export default __webpack_public_path__ + "assets/images/wheel-d07c47e61b92dae17e52b9d84d005499.svg";